<template>
  <div class="search-articles">
    <CategorySearchResult :id="12" :alias="'viktigt'" :title="'Viktigt'" />

    <!-- <h4 class="mb-md-2 font-weight-normal">Mina favoriter</h4>  -->
  </div>
</template>

<script>
import CategorySearchResult from "@/views/articles/CategorySearchResult.vue";

export default {
  components: {
    CategorySearchResult,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    addArticle: function() {
      const userId = JSON.parse(localStorage.getItem("user")).user.id;
      this.$store
        .dispatch("createArticle", { ownerId: userId })
        .then((response) => {
          this.$router.push({
            name: "article-add",
            params: { articleId: response.id, isNew: true, owner_id: userId },
          });
        });
    },
    searchQueryChanged: function(newVal) {
      this.searchQuery = newVal;
    },
    searchAllArticles: function() {
      this.$router.push({
        name: "articles-in-category",
        params: { alias: "Alla artiklar", id: 0, query: this.searchQuery },
      });
    },
  },
};
</script>
